import React, { useState, useEffect } from 'react';
import '../styles/TestimonialSlider.scss';

const TestimonialSlider = () => {
  // Sample testimonial data
  const testimonials = [
    {
      id: 1,
      name: "ARYAN MEHTA",
      videoThumbnail: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
      videoUrl: "#",
      testimonialText: "AstroVansh provided incredible insights into my life. The family-centric approach really helped me understand my destiny better."
    },
    {
      id: 2,
      name: "ROHAN SHARMA",
      videoThumbnail: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
      videoUrl: "#",
      testimonialText: "The Vedic astrology guidance was spot on. I'm amazed by the accuracy of their predictions and personalized approach."
    },
    {
      id: 3,
      name: "VIKRAM SINGH",
      videoThumbnail: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face",
      videoUrl: "#",
      testimonialText: "Their combination of Vastu, numerology, and astrology gave me a complete picture. Highly recommended for anyone seeking guidance."
    },
    {
      id: 4,
      name: "ADITYA KUMAR",
      videoThumbnail: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=400&h=400&fit=crop&crop=face",
      videoUrl: "#",
      testimonialText: "The personal astrologer service is fantastic. Having someone who understands my journey has been life-changing."
    },
    {
      id: 5,
      name: "ARJUN PATEL",
      videoThumbnail: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop&crop=face",
      videoUrl: "#",
      testimonialText: "Secure, confidential, and highly accurate. AstroVansh has become my go-to platform for all astrological guidance."
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPlaying) {
        setCurrentIndex((prevIndex) => 
          prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
        );
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [isPlaying, testimonials.length]);

  const nextSlide = () => {
    setCurrentIndex(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1);
  };

  const prevSlide = () => {
    setCurrentIndex(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const handlePlayVideo = () => {
    setIsPlaying(!isPlaying);
  };

  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = -2; i <= 2; i++) {
      let index = currentIndex + i;
      if (index < 0) index = testimonials.length + index;
      if (index >= testimonials.length) index = index - testimonials.length;
      visible.push({ ...testimonials[index], position: i });
    }
    return visible;
  };

  return (
    <section className="testimonial-slider">
      <div className="container">
        <div className="title">
          <h2>What Our Users Say</h2>
        </div>
        
        <div className="slider-container">
          <div className="testimonials-wrapper">
            {getVisibleTestimonials().map((testimonial, index) => (
              <div 
                key={`${testimonial.id}-${index}`}
                className={`testimonial-card ${testimonial.position === 0 ? 'active' : ''} position-${testimonial.position}`}
                onClick={() => testimonial.position === 0 && handlePlayVideo()}
              >
                <div className="video-container">
                  <img 
                    src={testimonial.videoThumbnail} 
                    alt={testimonial.name}
                    className="video-thumbnail"
                  />
                  {testimonial.position === 0 && (
                    <div className="play-button">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8 5v14l11-7z" fill="currentColor"/>
                      </svg>
                    </div>
                  )}
                </div>
                
                <div className="testimonial-content">
                  <h3 className="testimonial-name">{testimonial.name}</h3>
                  {testimonial.position === 0 && (
                    <p className="testimonial-text">{testimonial.testimonialText}</p>
                  )}
                </div>
                
                {testimonial.position !== 0 && (
                  <div className="nav-arrow">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d={testimonial.position < 0 ? "M15 18l-6-6 6-6" : "M9 18l6-6-6-6"} stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
          
          <div className="navigation-controls">
            <button className="nav-btn prev" onClick={prevSlide}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </button>
            
            <button className="nav-btn next" onClick={nextSlide}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </button>
          </div>
          
          <div className="dots-indicator">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;